import {
  afterRender,
  AfterViewInit,
  Component,
  Inject,
  InjectionToken,
  OnInit,
  Optional,
  PLATFORM_ID
} from '@angular/core';
import {CommonModule, DOCUMENT, isPlatformBrowser, isPlatformServer} from '@angular/common';
import { RouterOutlet } from '@angular/router';
import {RedirectionService} from "../../services/redirection.service";
import AOS from 'aos';
import {IframeService} from "../../services/iframe.service";
import {ThemeService} from "../../services/theme.service";
import {LanguageService} from "../../services/language.service";
import {SEOService} from "../../services/seo.service";
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit{
  constructor(public langService: LanguageService,
              @Inject(PLATFORM_ID) private platformId: Object,
              private themeService: ThemeService,
              public redirections: RedirectionService,
              public iframeService: IframeService,
              public seoService: SEOService,
  ) {}

  async ngOnInit() {
    await this.redirections.getRedirects();
    if(isPlatformServer(this.platformId)){
      this.seoService.setJsonLdScript();
    }
    if (isPlatformBrowser(this.platformId)) {
      AOS.init();
    }
  }

   ngAfterViewInit() {
    this.themeService.initCookieConsent();
  }

}
